import { render, staticRenderFns } from "./Post.vue?vue&type=template&id=b9b06102&"
import script from "./Post.vue?vue&type=script&lang=js&"
export * from "./Post.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9b06102')) {
      api.createRecord('b9b06102', component.options)
    } else {
      api.reload('b9b06102', component.options)
    }
    module.hot.accept("./Post.vue?vue&type=template&id=b9b06102&", function () {
      api.rerender('b9b06102', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/classPage/Post.vue"
export default component.exports